import React from 'react'

type BaseBageLogoProps = {
  logo: React.ReactNode | string | React.FC<React.SVGProps<SVGSVGElement>>
  name: string
}

export const BaseBageLogo = ({ logo, name }: BaseBageLogoProps) => {
  const renderLogo = () => {
    if (typeof logo === 'string') {
      return <img src={logo} alt={name} className="w-full h-full object-contain" />
    }

    if (typeof logo === 'function') {
      const LogoComponent = logo
      return <LogoComponent className="w-full h-full object-contain" />
    }

    return logo
  }

  return (
    <div className="flex items-center gap-2">
      <span className="flex-shrink-0 w-[18px] h-[18px]">{renderLogo()}</span>
      <span>{name}</span>
    </div>
  )
}
